import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { getCouponsStatements } from "@/api/coupons";
import { CouponsQueryKeys } from "./couponsQueryKeys";
import { getApiDateFilterBackend } from "@/utils/date";
import { useUser } from "@/tanstackQuery/queries";

import { DateRange } from "@/types/Date";

interface Options {
  type?: string;
  category?: string;
  date?: Date | DateRange;
  startDate?: string;
  endDate?: string;
  dealerIds?: number[];
  subDealerIds?: number[];
  userIds?: number[];
  statusList?: string[];
  names?: string[];
  sportCategory?: string;
  matchId?: string;
  q?: string;
  /** Scopes the statistics to the trash bin's soft-deleted coupons. */
  deleted?: boolean;
}

export const useCouponsStatement = (
  options: Options,
  queryOptions: { enabled?: boolean } = {}
) => {
  const user = useUser();

  return useQuery({
    queryKey: [CouponsQueryKeys.Statement, options],
    enabled: queryOptions.enabled ?? true,
    retry: false,
    queryFn: ({ signal }) => {
      const { date, ...restParams } = options;
      const params = {
        userId: user.id,
        ...restParams,
        ...getApiDateFilterBackend(date),
      };
      return getCouponsStatements({ signal, params });
    },
  });
};
